/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TopNotification.vue?vue&type=template&id=bbc5c5cc"
import script from "./TopNotification.vue?vue&type=script&lang=js"
export * from "./TopNotification.vue?vue&type=script&lang=js"
import style0 from "./TopNotification.vue?vue&type=style&index=0&id=bbc5c5cc&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports